var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"tiptap-btn",class:{ 'is-active': _vm.editor.isActive('bold') },attrs:{"type":"button","title":_vm.$t('Bold'),"disabled":_vm.disabled || !_vm.editor.can().chain().focus().toggleBold().run()},on:{"click":function($event){_vm.editor.chain().focus().toggleBold().run()}}},[_c('FormatBoldIcon',{attrs:{"size":"16"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }